<div mat-dialog-content
	class="cm-ranch-create-step-content">

	<ranch-basic-form
		[form]="form"
		[inEditMode]="false"
		(formReady)="setForm($event)">
	</ranch-basic-form>
</div>

<div mat-dialog-actions
	align="end">
	<button class="bk-button__delete"
		(click)="cancel()">
		{{ 'Cancel' | translate }}
	</button>

	<button mat-button
		class="bk-button bk-button--medium"
		[disabled]="!form || !form.valid"
		(click)="next()">
		{{ 'Next Step' | translate }}
	</button>
</div>
